import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.75 0C7.16421 0 7.5 0.335786 7.5 0.75V3H16.5V0.75C16.5 0.335786 16.8358 0 17.25 0C17.6642 0 18 0.335786 18 0.75V3H20.75C21.7165 3 22.5 3.7835 22.5 4.75V20.75C22.5 21.7165 21.7165 22.5 20.75 22.5H3.25C2.2835 22.5 1.5 21.7165 1.5 20.75V4.75C1.5 3.7835 2.2835 3 3.25 3H6V0.75C6 0.335786 6.33579 0 6.75 0ZM3.25 4.5C3.11193 4.5 3 4.61193 3 4.75V8H21V4.75C21 4.61193 20.8881 4.5 20.75 4.5H3.25ZM21 9.5H3V20.75C3 20.8881 3.11193 21 3.25 21H20.75C20.8881 21 21 20.8881 21 20.75V9.5Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgCalendar;
